/*
 * ALOLA (24-sep-2026): este archivo se cortaba en cada carga con
 * "VariantSelects is not defined" (ver variant-radios), asi que en vivo solo
 * llegaba a definirse variant-selects. Al corregir el error se quitaron los
 * bloques que venian despues y que NUNCA corrieron en la tienda
 * (pickup-availability, recipient-form, product-model, media-gallery,
 * sticky-atc, compare-checkbox): los que se usan tienen su propio archivo
 * (pickup-availability.js, recipient-form.js, product-model.js) y la version
 * de pickup-availability de este archivo inyectaba una copia de toda la pagina
 * dentro de la ficha. Se agrego product-add-to-cart-sticky (barra fija de compra).
 *
 * ALOLA (12-oct-2026, aviso de Cami): elegir un tamano NO cambiaba la variante. Ficha del
 * Therapiste: 250 ml agotado, se elegia 250 ml y el carrito recibia el de 450 ml sin decir "Agotado".
 * Este VariantSelects era de una version vieja que no calza con el markup del tema:
 *   - solo leia <select> y el tema usa botones (radios dentro de fieldset);
 *   - buscaba el JSON de variantes dentro del selector y el principal no lo trae (solo la barra fija);
 *   - usaba window.variantStrings y el tema los deja en window.theme.variantStrings.
 * Ahora lee selects y radios, toma el JSON del selector o de otro de la misma seccion, usa los textos
 * del tema, actualiza "Size: 250ml", sincroniza la barra fija y desactiva "Comprar ahora" si esta agotado.
 */

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabled = this.dataset.disabled === 'true';
    }
    connectedCallback() {
      this.addEventListener('change', this.onVariantChange);
    }
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updateOptionLabels();
      this.syncOtherPickers();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }

    text(key) {
      const strings = window.variantStrings || (window.theme && window.theme.variantStrings) || {};
      const fallback = { addToCart: 'Agregar al carrito', soldOut: 'Agotado', unavailable: 'No disponible' };
      return strings[key] || fallback[key] || '';
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      if (!fieldsets.length) {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
        return;
      }
      this.options = fieldsets.map((fieldset) => {
        const select = fieldset.querySelector('select');
        if (select) return select.value;
        const checked = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) => radio.checked);
        return checked ? checked.value : null;
      });
    }

    updateMasterId() {
      const variants = this.getVariantData();
      this.currentVariant = variants.find((variant) => {
        return !variant.options.some((option, index) => {
          return this.options[index] !== option;
        });
      });
    }

    // "Size: 250ml" junto a los botones
    updateOptionLabels() {
      Array.from(this.querySelectorAll('fieldset')).forEach((fieldset, index) => {
        const label = fieldset.querySelector('.form__label__value');
        if (label && this.options[index] != null) label.textContent = this.options[index];
      });
    }

    // La barra fija y la ficha muestran el mismo tamano (las dos compran con el mismo formulario)
    syncOtherPickers() {
      document.querySelectorAll(`variant-selects[data-section="${this.dataset.section}"]`).forEach((picker) => {
        if (picker === this) return;
        Array.from(picker.querySelectorAll('fieldset')).forEach((fieldset, index) => {
          const value = this.options[index];
          if (value == null) return;
          const select = fieldset.querySelector('select');
          if (select) { select.value = value; return; }
          fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => { radio.checked = radio.value === value; });
          const label = fieldset.querySelector('.form__label__value');
          if (label) label.textContent = value;
        });
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      if (mediaGallery && mediaGallery.setActiveMedia) mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }

    updateURL() {
      if (!this.currentVariant || !this.updateUrl) return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      // (12-oct, auditoría Fable) el formulario de cuotas se llama product-form-installment (sin sección): también se actualiza
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      const variant = this.currentVariant;
      // el boton se corrige al toque (sin esperar la red): agotado = "Agotado" y desactivado
      this.toggleAddButton(!variant.available, this.text('soldOut'));
      fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          if (this.currentVariant !== variant) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.section}`);

          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            destination.classList.remove('visibility-hidden');
          }
          // (12-oct, auditoría Fable) el precio de la barra fija también cambia con el tamaño
          const stickySource = html.getElementById(`price-${this.dataset.section}--sticky`);
          if (stickySource) {
            document.querySelectorAll(`[id="price-${this.dataset.section}--sticky"]`).forEach((el) => { el.innerHTML = stickySource.innerHTML; });
          }

          const skuSource = html.getElementById(`Sku-${this.dataset.section}`);
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          if (skuSource && skuDestination) skuDestination.innerHTML = skuSource.innerHTML;

          const inventorySource = html.getElementById(`Inventory-${this.dataset.section}`);
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;

          this.toggleAddButton(!variant.available, this.text('soldOut'));
        })
        .catch(() => {});
    }

    // Botones que compran con el formulario de la ficha: el principal, el de la barra fija y "Comprar ahora"
    addButtons() {
      const id = `product-form-${this.dataset.section}`;
      const productForm = document.getElementById(id);
      const buttons = [];
      if (productForm) productForm.querySelectorAll('[name="add"]').forEach((b) => buttons.push(b));
      document.querySelectorAll(`[name="add"][form="${id}"]`).forEach((b) => { if (!buttons.includes(b)) buttons.push(b); });
      return { productForm, buttons };
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const { productForm, buttons } = this.addButtons();
      if (!productForm) return;

      buttons.forEach((addButton) => {
        const addButtonText = addButton.querySelector(':scope > span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text && addButtonText) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          if (addButtonText) addButtonText.textContent = this.text('addToCart');
        }
      });
      productForm.querySelectorAll('[data-alola-comprar-ahora]').forEach((b) => {
        if (disable) b.setAttribute('disabled', 'disabled'); else b.removeAttribute('disabled');
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const { buttons } = this.addButtons();
      const price = document.getElementById(`price-${this.dataset.section}`);
      buttons.forEach((addButton) => {
        const addButtonText = addButton.querySelector(':scope > span');
        if (addButtonText) addButtonText.textContent = this.text('unavailable');
      });
      if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
      if (this.variantData) return this.variantData;
      // el JSON puede estar en este selector o en otro de la misma seccion (la barra fija siempre lo trae)
      const script = this.querySelector('[type="application/json"]') ||
        document.querySelector(`variant-selects[data-section="${this.dataset.section}"] [type="application/json"]`);
      this.variantData = script ? JSON.parse(script.textContent) : [];
      return this.variantData;
    }
  }

  customElements.define('variant-selects', VariantSelects);
}

if (!customElements.get('variant-radios')) {

  /**
   *  @class
   *  @function VariantRadios
   *  ALOLA (24-sep-2026): VariantSelects vive dentro del bloque if de arriba
   *  (scope de bloque), asi que "extends VariantSelects" lanzaba
   *  ReferenceError y cortaba el resto del archivo. Se toma la clase del registro.
   */
  class VariantRadios extends customElements.get('variant-selects') {
    constructor() {
      super();
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-add-to-cart-sticky')) {

  /**
   *  @class
   *  @function ProductAddToCartSticky
   *  ALOLA (24-sep-2026): el tema traia el markup y el CSS de la barra fija
   *  (snippets/product-add-to-cart-sticky.liquid) pero no este componente.
   *  La barra aparece cuando el boton principal de compra no esta en pantalla
   *  (arriba o abajo) y se esconde al llegar al footer. Sube el boton de
   *  WhatsApp y se acomoda sobre el aviso de cookies para no taparse.
   */
  class ProductAddToCartSticky extends HTMLElement {
    connectedCallback() {
      this.mainButton = document.getElementById('AddToCart');
      this.footer = document.querySelector('[id$="__footer"]') || document.querySelector('footer');
      this.cookieBars = Array.from(document.querySelectorAll('div[id^="alola-cookiebar-"]'));
      this.mainVisible = true;
      this.footerVisible = false;
      this.setupToggle();
      if (!this.mainButton || !('IntersectionObserver' in window)) return;

      // ALOLA (3-oct-2026, Ana): el boton principal solo cuenta como "a la vista" si se ve COMPLETO.
      // Si asoma cortado al pie de la pantalla (p. ej. en celular tras compactar la ficha), sigue la barra fija.
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.mainButton) this.mainVisible = entry.isIntersecting && entry.intersectionRatio >= 0.98;
          if (entry.target === this.footer) this.footerVisible = entry.isIntersecting;
        });
        this.update();
      }, { threshold: [0, 0.5, 0.98, 1] });
      this.observer.observe(this.mainButton);
      if (this.footer) this.observer.observe(this.footer);

      if (this.cookieBars.length) {
        this.cookieObserver = new MutationObserver(() => this.update());
        this.cookieBars.forEach((bar) => {
          this.cookieObserver.observe(bar, { attributes: true, attributeFilter: ['hidden'] });
        });
      }

      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.update(), 150);
      };
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.cookieObserver) this.cookieObserver.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      document.body.classList.remove('alola-sticky-atc-on');
      document.documentElement.style.removeProperty('--alola-sticky-space');
    }

    setupToggle() {
      const button = this.querySelector('button.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');
      if (!button || !content) return;
      button.addEventListener('click', (e) => {
        e.preventDefault();
        button.classList.toggle('sticky-open');
        content.classList.toggle('active');
        this.update();
      });
    }

    cookieHeight() {
      if (window.innerWidth >= 900) return 0;
      let height = 0;
      this.cookieBars.forEach((bar) => {
        if (!bar.hidden && bar.offsetHeight) height = Math.max(height, bar.offsetHeight);
      });
      return height ? height + 10 : 0;
    }

    update() {
      const visible = !this.mainVisible && !this.footerVisible;
      const extra = this.cookieHeight();
      this.style.setProperty('--alola-sticky-extra', `${extra}px`);
      this.classList.toggle('sticky--visible', visible);
      document.body.classList.toggle('alola-sticky-atc-on', visible);
      const base = window.innerWidth >= 768 ? 30 : 15;
      document.documentElement.style.setProperty('--alola-sticky-space', visible ? `${this.offsetHeight + extra + base}px` : '0px');
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}
